<template>
    <div>
        <top-bar
            :height="'48vh'"
            title="优惠券"
            :isShowRefresh="true"
            addTitle="添加"
            :loading="loading"
            @add="add"
            @refresh="refresh"
            @search="search"
            @generateRedeem="generateRedeem"
        />
        <div>
			<el-tabs v-model="activeCoupons" @tab-click="handleClick" type="card">
			    <el-tab-pane v-for="(tab, index) in tabs" :key="index" :name="tab.name">
			        <div
			            slot="label"
			            :style="{
			                color:
			                    activeCoupons == tab.name ? '#4dabf7' : theme.pageFontColor,
			            }"
			        >
			            {{ tab.title }}
			            <span>({{ tab.nums }})</span>
			        </div>
					<div class="couponInfo">
			            <div
			                class="card-nav"
			                v-if="tab.couponDatas.length != 0"
			            >
			                <div
			                    class="card-nav-div"
			                    v-for="(item, index) in tab.couponDatas"
			                    :key="index"
			                >
			                    <div
			                        class="card-nav-div-nav"
			                        :style="{
			                            backgroundImage:
			                                'url(http://ecar.meisenpay.com' + item.bg + ')',
			                            backgroundSize: '105% 100%',
			                            backgroundRepeat: 'no-repeat',
			                        }"
			                        @mouseenter="enter(item.id)"
			                        @mouseleave="item.overlay = false"
			                    >
			                        <div class="coupon">
			                            <div class="coupon-left">
			                                <el-image
												class="coupon-image"
			                                    :src="
			                                        'http://ecar.meisenpay.com' + item.icon
			                                    "
			                                    fit="fill"
			                                ></el-image>
			                            </div>
			                            <div class="coupon-right">
			                                <div class="coupon-name">
			                                    {{ item.name }}<div v-if="role === 0">({{platformText(item.platform_id)}})</div>
			                                </div>
			                                <div class="coupon-info textOver">
			                                    {{ item.info }}
			                                </div>
			                                <div class="coupon-info">
			                                    <span class="coupon-info-title">
			                                        金额：
			                                    </span>
			                                    {{ item.money / 100 }}￥
			                                </div>
			                                <div class="coupon-info">
			                                    <span class="coupon-info-title">
			                                        价格：
			                                    </span>
			                                    {{ item.price / 100 }}￥
			                                </div>
			                                <div class="coupon-info">
			                                    <span class="coupon-info-title">
			                                        使用次数：
			                                    </span>
			                                    {{ showTypeText(item.type) }}
			                                </div>
			                                <div class="coupon-info">
			                                    <span class="coupon-info-title">
			                                        有效期：
			                                    </span>
			                                    {{ item.expire }}天
			                                </div>
			                                <div class="coupon-info">
			                                    <span class="coupon-info-title">
			                                        满减金额：
			                                    </span>
			                                    {{ item.up / 100 }}￥
			                                </div>
			                            </div>
			                            <v-overlay
			                                absolute
			                                :value="item.overlay"
			                                opacity="0.3"
			                            >
			                                <el-button
			                                    type="primary"
			                                    @click="showDetails(item)"
			                                    class="mr-8"
			                                >
			                                    编辑
			                                </el-button>
			                                <el-button
			                                    class="ml-8"
			                                    type="danger"
			                                    @click="deleteCoupon(item)"
			                                >
			                                    删除
			                                </el-button>
			                            </v-overlay>
			                        </div>
			                    </div>
			                </div>
			            </div>
			            <v-img
			                v-if="tab.isHaveData"
			                width="100vw"
			                height="70vh"
			                src="@/assets/no_data.svg"
			            ></v-img>
					</div>
			    </el-tab-pane>
			</el-tabs>
        </div>
        <v-dialog scrollable v-model="isOpenDialog" width="60em" overlay-color="#262626">
            <coupon-form
                v-if="isOpenDialog"
                @cancel="cancel"
                :isAdd="isAdd"
                :isEdit="isEdit"
                @refresh="refresh"
                :couponData="couponData"
            />
        </v-dialog>
        <v-dialog scrollable v-model="isShowRedeem" width="40em" overlay-color="#262626">
            <RedeemForm @cancel="cancel" v-if="isShowRedeem" />
        </v-dialog>
    </div>
</template>
<script>
import { mapState } from "vuex";
import store from "@/store";
import Public from "@/public";
import TopBar from "@/components/TopBar";
import util from "@/util/index";
import CouponForm from "@/components/Form/CouponForm";
import RedeemForm from "@/components/Form/RedeemForm";
export default {
    name: "Template",
    data() {
        return {
            tabs: [
                {
                    name: "first",
                    title: "上架",
                    index: 1,
                    nums: 0,
                    couponDatas: [],
                    isHaveData: true, //是否存在优惠券数据
                },
                {
                    name: "second",
                    title: "下架",
                    index: 0,
                    nums: 0,
                    couponDatas: [],
                    isHaveData: true, //是否存在优惠券数据
                },
            ],
            activeName: "first",
            activeCoupons: "first",
            couponDatas: [], //所有优惠券数据信息
            couponData: null, //向表单传递的优惠券信息
            isAdd: false, //是否添加
            isEdit: false, //是否修改
            loading: false, //加载
            isOpenDialog: false, //是否打开模态框
            isShowRedeem: false, //是否打开生成兑换码模态框
        };
    },
    mounted() {
        // this.refresh();
        if (this.$route.path == "/coupons/template") {
            document.getElementsByClassName("el-tabs__nav-wrap")[0].style.width = "100vw";
            document.getElementsByClassName("el-tabs__nav-wrap")[0].style.position = "fixed";
            document.getElementsByClassName("el-tabs__nav-wrap")[0].style.zIndex = "100";
            document.getElementsByClassName("el-tabs__nav-wrap")[0].style.top = "3rem";
        }
    },
    watch: {
        isOpenDialog: {
            handler(val) {
                if (val == true) {
                } else {
                    this.isEdit = false;
                    this.isAdd = false;
                }
            },
        },
    },
    computed: {
        ...mapState(["theme", "couponInfos","role","platformList"]),
    },
    components: {
        TopBar,
        CouponForm,
        RedeemForm,
    },
    methods: {
        handleClick(tab, event) {
            // console.log(tab);
        },
        //生成兑换码
        generateRedeem() {
            this.isShowRedeem = true;
        },
        /*搜索*/
        search(reg) {
            let datas = [];
            for (let i = 0; i < this.couponInfos.length; i++) {
                if (
                    reg.test(this.couponInfos[i].name) ||
                    reg.test(this.couponInfos[i].info) ||
                    reg.test(this.couponInfos[i].expire) ||
                    reg.test(this.couponInfos[i].price) ||
                    reg.test(this.couponInfos[i].id)
                ) {
                    datas.push(this.couponInfos[i]);
                }
            }
            util.ShowTip("查询到" + datas.length + "条数据", 1);
            for (let j = 0; j < this.tabs.length; j++) {
                this.tabs[j].couponDatas = [];
                this.tabs[j].nums = 0;
            }
            for (let j = 0; j < this.tabs.length; j++) {
                for (let i = 0; i < datas.length; i++) {
                    datas[i].overlay = false;
                    if (datas[i].valid === this.tabs[j].index) {
                        this.tabs[j].couponDatas.push(datas[i]);
                        this.tabs[j].nums += 1;
                    }
                }
            }
            for (let i = 0; i < this.tabs.length; i++) {
                if (this.tabs[i].couponDatas.length != 0) {
                    this.tabs[i].isHaveData = false;
                } else {
                    this.tabs[i].isHaveData = true;
                }
            }
        },
        /*刷新*/
        refresh() {
            this.loading = true;
            this.getData();
			if(this.role === 0) {
				this.getPlatformList()
			}
        },
        /*添加*/
        add() {
            this.isOpenDialog = true;
            this.isAdd = true;
        },
        /*获取优惠券信息*/
        async getData() {
            let params = {
                postData: {},
                callback: () => {
                    this.loading = false;
                },
            };
            await store.dispatch("getCoupon", params);
            let datas = this.JsonData(this.couponInfos);
            datas.sort(Public.createComprisonFunction("id"));
            for (let j = 0; j < this.tabs.length; j++) {
                this.tabs[j].couponDatas = [];
                this.tabs[j].nums = 0;
            }
            for (let j = 0; j < this.tabs.length; j++) {
                for (let i = 0; i < datas.length; i++) {
                    datas[i].overlay = false;
                    if (datas[i].valid === this.tabs[j].index) {
                        this.tabs[j].couponDatas.push(datas[i]);
                        this.tabs[j].nums += 1;
                    }
                }
            }
            for (let i = 0; i < this.tabs.length; i++) {
                if (this.tabs[i].couponDatas.length != 0) {
                    this.tabs[i].isHaveData = false;
                } else {
                    this.tabs[i].isHaveData = true;
                }
            }
        },
        /*获取平台*/
        async getPlatformList() {
            let postData = {};
            await store.dispatch("getplatformList", postData);
        },
		/*显示优惠券详情*/
        showDetails(couponData) {
            this.isOpenDialog = true;
            this.isEdit = true;
            this.couponData = couponData;
        },
        /*删除优惠券*/
        deleteCoupon(couponData) {
            let params = {
                postData: { id: couponData.id },
                callback: () => {
                    this.refresh();
                },
            };
            const h = this.$createElement;
            this.$confirm("是否删除优惠券：" + couponData.name, "提示", {
                title: "提示",
                message: h("p", null, [
                    h("span", null, "是否删除优惠券模板：  "),
                    h("i", { style: "color: red" }, couponData.name),
                ]),
                showCancelButton: true,
                center: true,
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    store.dispatch("deleteCoupon", params);
                })
                .catch(() => {});
        },
        /*取消*/
        cancel() {
            if (this.isShowRedeem) {
                this.isShowRedeem = false;
            }
            this.isOpenDialog = false;
            this.isAdd = false;
            this.isEdit = false;
            this.couponData = null;
        },
        /*鼠标移入*/
        enter(id) {
            for (let i = 0; i < this.tabs.length; i++) {
                for (let j = 0; j < this.tabs[i].couponDatas.length; j++) {
                    this.tabs[i].couponDatas[j].overlay = false;
                    if (this.tabs[i].couponDatas[j].id == id) {
                        this.tabs[i].couponDatas[j].overlay = true;
                    }
                }
            }
        },
        JsonData(data) {
            return JSON.parse(JSON.stringify(data));
        },
        /*显示使用次数文本*/
        showTypeText(type) {
            let typeText = [
                {
                    id: 0,
                    value: "无限制",
                },
                {
                    id: 1,
                    value: "一次性",
                },
            ];
            let text;
            for (let i = 0; i < typeText.length; i++) {
                if (type === typeText[i].id) {
                    text = typeText[i].value;
                }
            }
            return text;
        },
		platformText(platformId) {
			let text = "";
			for (let i = 0; i < this.platformList.length; i++) {
			    if (platformId === this.platformList[i].id) {
			        text = this.platformList[i].platform_name;
			    }
			}
			return text;
		},
    },
};
</script>

<style scoped>
.couponInfo {
	width: 100%;
	height: 90vh;
	overflow-y:auto;
	overflow-x: hidden;
}
.textOver {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
}
.card-nav {
    width: 100vw;
    height: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
@media  (max-width: 600px) {
	.card-nav-div {
	    width: 100%;
	    height: 25vh;
	    display: flex;
	    justify-content: center;
	    align-items: center;
	}
	.card-nav-div-nav {
	    width: 90%;
	    height: 90%;
	    /* background: #ffffff; */
	}
	.coupon {
	    position: relative;
	    width: 100%;
	    height: 100%;
	    display: flex;
	    flex-direction: row;
	}
	.coupon-left {
	    width: 35%;
	    height: 100%;
	    display: flex;
	    justify-content: center;
	    align-items: center;
	    /* border: 1px solid red; */
	}
	.coupon-image {
		width: 60px; 
		height: 60px
	}
	.coupon-right {
	    width: 65%;
	    height: 100%;
	    display: flex;
	    flex-direction: column;
	    /* background: #f5f5f5; */
	    opacity: 0.6;
	    /* border: 1px solid blue; */
	}
	.coupon-name {
	    width: 80%;
	    height: 20%;
	    display: flex;
	    font-size: 0.7vw;
	    justify-content: center;
	    align-items: center;
	}
	.coupon-info{
		font-size:0.5vw;
	}
	.coupon-info-title {
	    font-size: 0.5vw;
	}
}
@media  (min-width: 600px) {
	.card-nav-div {
	    width: 42.5vw;
	    height: 25vh;
	    display: flex;
	    justify-content: center;
	    align-items: center;
	}
	.card-nav-div-nav {
	    width: 90%;
	    height: 90%;
	    /* background: #ffffff; */
	}
	.coupon {
	    position: relative;
	    width: 100%;
	    height: 100%;
	    display: flex;
	    flex-direction: row;
	}
	.coupon-left {
	    width: 35%;
	    height: 100%;
	    display: flex;
	    justify-content: center;
	    align-items: center;
	    /* border: 1px solid red; */
	}
	.coupon-image {
		width: 100px; 
		height: 100px
	}
	.coupon-right {
	    width: 65%;
	    height: 100%;
	    display: flex;
	    flex-direction: column;
	    /* background: #f5f5f5; */
	    opacity: 0.6;
	    /* border: 1px solid blue; */
	}
	.coupon-name {
	    width: 80%;
	    height: 25%;
	    display: flex;
	    font-size: 1.3vw;
	    justify-content: center;
	    align-items: center;
	}
	.coupon-info{
		font-size:0.8vw;
	}
	.coupon-info-title {
	    font-size: 0.8vw;
	}
}

.el-carousel__item:nth-child(2n) {
    /* background: url("../assets/coupons.png") no-repeat; */
    background-size: cover;
}

.el-carousel__item:nth-child(2n + 1) {
    /* background: url("../assets/coupons.png") no-repeat; */
    background-size: cover;
}

.el-dropdown-link {
    cursor: pointer;
    color: #141414;
}
.el-icon-arrow-down {
    font-size: 2vw;
}
</style>
